import type { FlagConfiguration } from '@atlassian/jira-flags/src/services/types'; // ignore-for-ENGHEALTH-17759
import messages from './messages.tsx';

export const onColumnsChangeErrorFlag: FlagConfiguration = {
	type: 'error',
	title: messages.configureColumnsErrorTitle,
	description: messages.columnConfigMutationErrorDescription,
	isAutoDismiss: true,
	messageId: 'issue-view-child-issues-panel.common.flags.on-columns-change-error-flag.error',
	messageType: 'transactional',
};

export const onChildIssueResizeErrorFlag: FlagConfiguration = {
	type: 'error',
	title: messages.columnResizeMutationErrorTitle,
	description: messages.columnResizeMutationErrorDescription,
	isAutoDismiss: true,
	messageId: 'issue-view-child-issues-panel.common.flags.on-child-issue-resize-error-flag.error',
	messageType: 'transactional',
};
